<template>
  <div class="baniere">
    <popupProject
      :want-to-make-offer="activeProjet"
      @oga="retourProjet"
    />
    <div class="flou">
      .
    </div>
    <div class="flou2">
      .
    </div>
    <div class="bloc md:flex md:pt-24 pt-0">
      <div class="md:w-1/2 w-full md:pt-24 pt-6 main">
        <div class="title w-full mt-6 motion">
          Nous conçevons des solutions digitales pour révolutionner votre business.
        </div>
        <div
          class="button"
          data-aos="fade-up"
          data-aos-duration="2000"
          @click="openProjet"
        >
          Vous avez un projet ?
        </div>
      </div>
      <div
        class="md:w-1/2 w-full md:mt-0 mt-10 image-bloc"
        data-aos="fade-left"
        data-aos-duration="2000"
      />
    </div>
  </div>
</template>

<script>
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Index',
  components: {
    popupProject
  },
  props: {
  },
  data () {
    return {
      activeProjet: false
    }
  },
  methods: {
    openProjet () {
      this.activeProjet = true
    },
    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $devs_color;
   position: relative;
   padding-left: $padding-l;
 }
  .flou{
    background: #FEDDA0;
    opacity: 0.25;
   filter: blur(200px);
    position: absolute;
    width: 710px;
    height: 710px;
    left: 834px;
    top: -103px;
  }
  .flou2{
    position: absolute;
    width: 810px;
    height: 780px;
    left: -165px;
    top: 235px;
    //background: #97AAED;
    background-color: #fd85b1ad;
    opacity: 0.4;
    filter: blur(200px);
  }

  .image-bloc{
    background-image: url("../../../assets/images/png/man.png");
    height: 715px;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
  }
  .button{
    background-color: $dev-green;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: white;
  }
  .title{
    font-style: normal;
    font-weight: 800;
    font-size: 48px;
    line-height: 180%;
    letter-spacing: 0.01em;
    color: white;

  }

  .motion {
    display: inline-block;
    position: relative;
  }
  .motion::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0px;
    right: 100%;
    bottom: 0px;
    left: 0px;
    background-color: white;
    animation: motion 0.4s .2s ease forwards;
  }
  .motion > * {
    opacity: 0;
    animation: opacity 0.2s .2s ease forwards;
  }

  @keyframes motion {
    0% {
      left: 0px;
      right: 100%;
    }
    50% {
      left: 0px;
      right: 0px;
    }
    100% {
      left: 100%;
      right: 0px;
    }
  }
  @keyframes opacity {
    0% { opacity: 0; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }

  @media screen and (max-width: 700px){
    .baniere{
      padding-left: 30px;
    }
    .title{
      font-size: 32px;
    }
    .button{
      height: 50.32px;
      font-size: 20.1293px;
    }
    .image-bloc{
      height: 435.81px;
    }
    .flou{
      position: absolute;
      width: 710px;
      height: 310px;

      left: 200px;
      top: -90px;
    }

  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
    }
    .title{
      font-size: 35px;
    }
    .main{
      padding-top: 50px;
      padding-top: 30px;
    }
    .button{
      height: 50.32px;
      font-size: 20.1293px;
    }
    .image-bloc{
      height: 435.81px;
    }
    .flou{
      position: absolute;
      width: 710px;
      height: 310px;

      left: 200px;
      top: -90px;
    }

  }
</style>
